import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

type FilterKey = 'all' | 'trucking' | 'surface_rentals';

interface TaskFilterChipsProps {
  active: FilterKey;
  counts: { all: number; trucking: number; surface_rentals: number };
  onChange: (filter: FilterKey) => void;
}

const filters: { key: FilterKey; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'trucking', label: 'Trucking' },
  { key: 'surface_rentals', label: 'Rentals' },
];

/**
 * A vertical's chip shows only for a tenant that HAS that vertical (positive
 * guards): a trucking-only driver saw "Rentals · 0" beside "Trucking · 1"
 * (fix/driver-app-trucking). With one vertical the split says nothing "All"
 * does not, so no chips are drawn at all.
 */
export default function TaskFilterChips({ active, counts, onChange }: TaskFilterChipsProps) {
  const { hasVertical } = useAuth();
  const shown = filters.filter((f) => f.key === 'all' || hasVertical(f.key));
  if (shown.length <= 2) return null;
  // Hide if only "All" has items (no multi-vertical mix)
  if (counts.trucking === 0 && counts.surface_rentals === 0) return null;

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-1 -mx-1 px-1">
      {shown.map((f) => {
        const isActive = active === f.key;
        return (
          <button
            key={f.key}
            onClick={() => onChange(f.key)}
            className={`shrink-0 rounded-full border px-3.5 h-9 text-xs font-semibold transition-colors ${
              isActive
                ? 'bg-white text-fieldiq-dark border-white'
                : 'bg-transparent text-white border-fieldiq-border hover:bg-fieldiq-card/40'
            }`}
          >
            {f.label} · {counts[f.key]}
          </button>
        );
      })}
    </div>
  );
}
